import validate from "/opt/build/repo/node_modules/.pnpm/nuxt@3.15.2_@parcel+watcher@2.5.1_@types+node@22.13.5_db0@0.2.4_eslint@8.57.1_ioredis@5.5.0_m_57rknjok6nif4yecs2w4dqozma/node_modules/nuxt/dist/pages/runtime/validate.js";
import _1_45set_45user_45global from "/opt/build/repo/apps/spa/middleware/1.setUser.global.ts";
import _2_45toc_45global from "/opt/build/repo/apps/spa/middleware/2.TOC.global.ts";
import mixpanel_45global from "/opt/build/repo/apps/spa/middleware/mixpanel.global.ts";
import manifest_45route_45rule from "/opt/build/repo/node_modules/.pnpm/nuxt@3.15.2_@parcel+watcher@2.5.1_@types+node@22.13.5_db0@0.2.4_eslint@8.57.1_ioredis@5.5.0_m_57rknjok6nif4yecs2w4dqozma/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _1_45set_45user_45global,
  _2_45toc_45global,
  mixpanel_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/opt/build/repo/node_modules/.pnpm/@nuxt-alt+auth@2.7.6_magicast@0.3.5_nuxi@3.22.2_typescript@5.7.3_vue@3.5.13_typescript@5.7.3_/node_modules/@nuxt-alt/auth/dist/runtime/core/middleware.mjs"),
  "is-admin": () => import("/opt/build/repo/apps/spa/middleware/isAdmin.ts"),
  "is-client": () => import("/opt/build/repo/apps/spa/middleware/isClient.ts"),
  "is-freeflexer": () => import("/opt/build/repo/apps/spa/middleware/isFreeflexer.ts"),
  "official-rep": () => import("/opt/build/repo/apps/spa/middleware/officialRep.ts"),
  onboarding: () => import("/opt/build/repo/apps/spa/middleware/onboarding.ts"),
  unauth: () => import("/opt/build/repo/apps/spa/middleware/unauth.ts")
}